export default "__VITE_ASSET__DNnkn7Gg__"